/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable max-len */
import React from 'react';
import styled from 'styled-components';
import {
    Alert, EditableText, InputGroup, NumericInput, Menu, MenuItem, Popover, Tooltip
} from '@blueprintjs/core';
import {
    faCog, faTrashAlt, faClone
} from '@fortawesome/free-solid-svg-icons';
/* eslint-disable import/no-unresolved */
import ReactResizeDetector from 'react-resize-detector';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {PortalOverflowOverlay} from '../../../lib/overlays';
import {BlueBorderButton, BlueButton} from '../../../lib/buttons';
import {WhiteBlueScrollBar} from '../../../lib/scrollbar';
import {TextBox} from '../../../lib/text-box';

const FormHeader = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;
    font-size: 24px;
    font-weight: bold;
    color: #16335B;
    position: relative;
`;

const SettingsDiv = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const TextRow = styled.div`
    width: 100%;
    color: #3B3C3E;
    background-color: #E1E1E1;
    margin: 5px 5px 0px 0px;
    border-radius: 5px;
    padding: 5px;
    class: column;
    display: flex;
    justify-content: space-between;
`;

class RobotState extends React.Component {
    constructor(props) {
        super(props);

        this.type = props.type;
        this.updateItem = props.updateItem;
        this.deleteItem = props.deleteItem;
        this.cloneComponent = props.cloneComponent;

        this.state = {
            id: props.id,
            availableSources: props.availableSources,
            name: props.initialState.name || 'Value',
            
            source: props.initialState.source || 'Select source',
            varAPIKey: props.initialState.varAPIKey || '',
            varEntityType: props.initialState.varEntityType || '', 
            varTimeout: props.initialState.varTimeout || 1000,
            
            tempSource: 'Select source',
            tempAPIKey: '',
            tempEntityType: '',
            tempTimeout: 1000,
            
            popoverOpen: false,
            deletePopupOpen: false,
            fontSize: 10
        };
        this.value = 50;

        this.sendUpdate = this.sendUpdate.bind(this);
        this.delete = this.delete.bind(this);
        this.changeName = this.changeName.bind(this);
        this.openPopup = this.openPopup.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.closeConfirmPopup = this.closeConfirmPopup.bind(this);
        this.openDelete = this.openDelete.bind(this);
        this.closeDelete = this.closeDelete.bind(this);
        this.renderItems = this.renderItems.bind(this);
        this.resize = this.resize.bind(this);
        this.changeSource = this.changeSource.bind(this);
        this.changeAPIKeyVar = this.changeAPIKeyVar.bind(this);
        this.changeEntityTypeVar = this.changeEntityTypeVar.bind(this);
        this.changeTimeoutVar = this.changeTimeoutVar.bind(this);
        this.clone = this.clone.bind(this);
        
        this.numbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
    }

    static getDerivedStateFromProps(props) {
        return {
            id: props.id,
            availableSources: props.availableSources,
            name: props.initialState.name || 'Value',
            source: props.initialState.source || 'Select source',
            varAPIKey: props.initialState.varAPIKey || '',
            varEntityType: props.initialState.varEntityType || '',
            varTimeout: props.initialState.varTimeout || 1000            
        };
    }

    componentDidUpdate(__, prevState) {
        const {id, unit} = this.state;
        if (unit !== prevState.unit) {
            const height = document.getElementById(`valueDiv_${id}`).offsetHeight;
            const width = document.getElementById(`valueDiv_${id}`).offsetWidth;
            this.resize(width, height);
        }
    }

    sendUpdate(key, value) {
        const {id} = this.state;
        this.updateItem(id, key, value);
    }

    delete() {
        const {id} = this.state;
        this.setState({deletePopupOpen: false});
        this.deleteItem(id);
    }

    changeName(value) {
        this.sendUpdate('name', value);
    }

    openPopup() {
        const {source, varAPIKey, varEntityType, varTimeout} = this.state;
        this.setState({
            popoverOpen: true,
            tempSource: source,
            tempAPIKey: varAPIKey,
            tempEntityType: varEntityType,
            tempTimeout: varTimeout
        });
    }

    closePopup() {
        this.setState({
            popoverOpen: false,
            tempSource: 'Select source',
            tempAPIKey: '',
            tempEntityType: '',
            tempTimeout: 1000
        });
    }

    closeConfirmPopup() {
        const {tempSource, tempAPIKey, tempEntityType, tempTimeout} = this.state;
        this.sendUpdate('source', tempSource);
        this.sendUpdate('varAPIKey', tempAPIKey);
        this.sendUpdate('varEntityType', tempEntityType);
        this.sendUpdate('varTimeout', tempTimeout);
        this.setState({popoverOpen: false});
    }

    openDelete() {
        this.setState({deletePopupOpen: true});
    }

    closeDelete() {
        this.setState({deletePopupOpen: false});
    }

    resize(width, height) {
        this.setState({fontSize: Math.min(height, (width / 5))});
        // this.setState({fontSize: Math.min(height, (width / (String(this.value).length + unit.length)))});
    }

    changeSource(value) {
        this.setState({tempSource: value});
    }

    changeAPIKeyVar(event) {
        event.stopPropagation();
        this.setState({tempAPIKey: event.target.value});
    }

    changeEntityTypeVar(event) {
        event.stopPropagation();
        this.setState({tempEntityType: event.target.value});
    }

    changeTimeoutVar(value) {
        this.setState({tempTimeout: value});
    }

    clone() {
        const {id} = this.state;
        this.closePopup();
        this.cloneComponent(id);
    }

    renderItems() {
        const listedItems = this.numbers.map((number) => (
            <div
                style={{
                    width: '100%', height: '100%', display: 'flex', flexDirection: 'row'
                }}
            >
                <div
                    style={{
                        width: '30px',
                        background: '#7ABF43',
                        margin: '5px 5px 0px 0px',
                        borderRadius: '5px',
                        filter: 'blur(2px)',
                        animation: 'blink 2s linear infinite'
                    }}
                />                
                <TextRow>
                    <div
                        style={{
                            width: 'calc(100% - 25px)',
                            display: 'grid',
                            gridTemplateColumns: 'auto auto auto',
                            justifyContent: 'space-between',
                        }}
                    >
                        <TextBox>Robot</TextBox>
                        <TextBox>{number}</TextBox>
                        <TextBox>IDLE</TextBox>
                    </div>
                </TextRow>
            </div>
        ));

        return listedItems;
    }

    render() {
        const {id, availableSources, name, popoverOpen, deletePopupOpen, fontSize, tempSource, tempAPIKey, tempEntityType, tempTimeout} = this.state;

        return ([
            <div
                style={{
                    width: '100%', height: '100%', background: 'white', padding: '1%', display: 'flex', flexDirection: 'column', borderRadius: '10px', fontSize: '16px'
                }}
            >
                <div
                    style={{
                        width: '100%',
                        height: '25px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        background: '#16335B',
                        borderTopLeftRadius: '10px',
                        borderTopRightRadius: '10px',
                        position: 'relative',
                        fontSize: '13px'
                    }}
                >
                    <div onMouseDown={(e) => e.stopPropagation()}>
                        <EditableText className="name-edit" onChange={this.changeName} onMouseDown={(e) => e.stopPropagation()} placeholder="Component Name" value={name} />
                    </div>
                    <div
                        style={{
                            height: '100%',
                            position: 'absolute',
                            top: '0px',
                            right: '2%',
                            display: 'flex',
                            alignItems: 'center'
                        }}
                        onMouseDown={(e) => e.stopPropagation()}
                    >
                        <div style={{paddingRight: '5px'}}>
                            <Tooltip content="Clone component" popoverClassName="item-info-tooltip">
                                <FontAwesomeIcon icon={faClone} style={{color: 'white', fontSize: '13px', cursor: 'pointer'}} onClick={this.clone} />
                            </Tooltip>
                        </div>
                        <FontAwesomeIcon icon={faCog} style={{color: 'white', cursor: 'pointer'}} onClick={this.openPopup} />
                    </div>
                    <div
                        style={{
                            height: '100%',
                            position: 'absolute',
                            top: '0px',
                            left: '2%',
                            display: 'flex',
                            alignItems: 'center'
                        }}
                        onMouseDown={(e) => e.stopPropagation()}
                    >
                        <FontAwesomeIcon icon={faTrashAlt} style={{color: '#DE162F', cursor: 'pointer'}} onClick={this.openDelete} />
                    </div>
                </div>
                <ReactResizeDetector onResize={this.resize}>
                    {() => (
                        <div
                            id={`valueDiv_${id}`}
                            style={{
                                width: '100%',
                                height: 'calc(100% - 25px)',
                                maxHeight: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                flexDirection: 'column',
                                color: '#16335B',
                                fontSize: `${fontSize}px`
                            }}
                        >
                            <WhiteBlueScrollBar>
                                {this.renderItems()}
                            </WhiteBlueScrollBar>
                        </div>
                    )}
                </ReactResizeDetector>
            </div>,
            <PortalOverflowOverlay key="settings" id="settings" isOpen={popoverOpen} width="450px" height="auto" background="white" borderRadius="10px" padding="20px" marginLeft="auto" marginRight="auto" color="black">
                <FormHeader>
                    {`${name} Settings`}
                </FormHeader>
                <SettingsDiv>
                    <Popover popoverClassName="custom-popover">
                        <BlueBorderButton type="button" width="410px" rightIcon="caret-down">
                            {tempSource}
                        </BlueBorderButton>
                        <Menu>
                            {availableSources.map((s) => (
                                <MenuItem text={s} onClick={() => this.changeSource(s)} />
                            ))}
                        </Menu>
                    </Popover>       
                    <div
                        style={{
                            width: '100%', height: '100%', marginTop: '10px', display: 'flex', alignItems: 'center'
                        }}
                    >
                        <InputGroup
                            leftIcon="key"
                            placeholder="API Key"
                            onChange={this.changeAPIKeyVar}
                            value={tempAPIKey}
                            fill
                            large
                        />
                    </div>
                    <div
                        style={{
                            width: '100%', height: '100%', marginTop: '10px', display: 'flex', alignItems: 'center'
                        }}
                    >
                        <InputGroup
                            leftIcon="array"
                            placeholder="Entity Type"
                            onChange={this.changeEntityTypeVar}
                            value={tempEntityType}
                            fill
                            large
                        />
                    </div>

                    <div
                        style={{
                            width: '100%', height: '100%', marginTop: '10px', display: 'flex', alignItems: 'center'
                        }}
                    >
                        <div
                            style={{
                                width: '50%', height: '100%', display: 'flex', alignItems: 'center', color: '#16335B', fontSize: '16px'
                            }}
                        >
                            Timeout (ms):
                        </div>
                        <div style={{width: '50%', height: '100%', display: 'flex', alignItems: 'center'}}>
                            <NumericInput
                                className="numeric-input"
                                clampValueOnBlur
                                minorStepSize={10}
                                onValueChange={this.changeTimeoutVar}
                                placeholder="Timeout"
                                stepSize={100}
                                majorStepSize={1000}
                                defaultValue={+tempTimeout.toFixed(0)}
                                fill
                            />
                        </div>
                    </div>

                    <div
                        style={{
                            width: '300px', display: 'flex', alignItems: 'center', justifyContent: 'space-evenly', marginTop: '10px'
                        }}
                    >
                        <BlueBorderButton
                            id="cancel"
                            type="button"
                            onClick={this.closePopup}
                        >
                            Cancel
                        </BlueBorderButton>
                        <BlueButton
                            id="save"
                            type="button"
                            onClick={this.closeConfirmPopup}
                        >
                            Save
                        </BlueButton>
                    </div>
                </SettingsDiv>
            </PortalOverflowOverlay>,
            <Alert key="delete-alert" style={{background: 'white', color: 'black'}} usePortal cancelButtonText="Cancel" confirmButtonText="Delete" icon="trash" intent="danger" isOpen={deletePopupOpen} onCancel={this.closeDelete} onConfirm={this.delete}>
                <p>
                    Are you sure you want to delete the component
                    <b style={{marginLeft: '5px'}}>{name}</b>
                    ?
                </p>
            </Alert>
        ]);
    }
}

const createRobotState = ({id, type, initialState, updateItem, deleteItem, cloneComponent, sources}) => (
    <RobotState
        id={id}
        type={type}
        initialState={initialState}
        updateItem={updateItem}
        deleteItem={deleteItem}
        cloneComponent={cloneComponent}
        availableSources={sources}
    />
);

export default createRobotState;
